let pushNavigationInProgress = false;

export function handlePushNavigation(router) {
  if (pushNavigationInProgress) return;

  const urlParams = new URLSearchParams(window.location.search);
  const pushIdFromUrl = urlParams.get("pushId");
  const currentPath = window.location.pathname;

  if (pushIdFromUrl) {
    pushNavigationInProgress = true;
    window.history.replaceState({}, "", currentPath);

    const eventName = currentPath.includes("/tareas")
      ? "open-tarea-modal"
      : "open-tramite-modal";

    window.dispatchEvent(
      new CustomEvent(eventName, { detail: { id: pushIdFromUrl } }),
    );
    setTimeout(() => {
      pushNavigationInProgress = false;
    }, 3000);
    return;
  }

  const cookies = document.cookie.split("; ");
  const rutaPushCookie = cookies.find((row) => row.startsWith("rutaPush="));
  const pushIdCookie = cookies.find((row) => row.startsWith("pushId="));

  if (!rutaPushCookie) return;

  pushNavigationInProgress = true;

  const url = decodeURIComponent(rutaPushCookie.split("=")[1]);
  const id = pushIdCookie
    ? decodeURIComponent(pushIdCookie.split("=")[1])
    : null;

  const clearOptions = "expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  document.cookie = `rutaPush=; ${clearOptions}`;
  document.cookie = `pushId=; ${clearOptions}`;

  router.push(url).then(() => {
    const eventName = url.includes("/tareas")
      ? "open-tarea-modal"
      : "open-tramite-modal";

    setTimeout(() => {
      window.dispatchEvent(new CustomEvent(eventName, { detail: { id } }));
      setTimeout(() => {
        pushNavigationInProgress = false;
      }, 3000);
    }, 300);
  });
}
